import { z } from 'zod';

const MMC = 'montefiore_mmc';
const WHP = 'montefiore_wph';
const MEAC = 'montefiore_meac';
const ACME = 'acme';
const WHP_KEY = 'wph';
const MMC_KEY = 'mmc';
const MEAC_KEY = 'meac';
const ACME_KEY = 'acme';
const MMV_KEY = 'mmv';
const MNR_KEY = 'mnr';

export const CLIENT_ORG_CONTEXT_ENUM = z.enum([MMC, WHP, MEAC, ACME]);
export const CLIENT_ORG_CONTEXT_INITIALS_ENUM = z.enum([
  MMC_KEY,
  WHP_KEY,
  MEAC_KEY,
  ACME_KEY,
  MMV_KEY,
  MNR_KEY,
]);

export type ClientOrgContextKey = z.infer<typeof CLIENT_ORG_CONTEXT_ENUM>;
export type ClientOrgContextInitials = z.infer<
  typeof CLIENT_ORG_CONTEXT_INITIALS_ENUM
>;
export const ContextKeySchema = CLIENT_ORG_CONTEXT_ENUM;

/** Wire shape only; unknown keys fail later in `getClientOrgConfig`. */
export const DirectoryKeyFromApiSchema = z.string().min(1);

export const organizationLocationSchema = z.object({
  code: z.string(),
  name: z.string(),
  sites: z.object({
    providers: z.object({
      domain: z.string(),
      context: ContextKeySchema,
      configuration: z.object({
        frontend: z.object({
          visitTypes: z.array(
            z.object({
              scope: z.string(),
              ehrVisitTypeId: z.string(),
            }),
          ),
        }),
      }),
    }),
  }),
});
export type OrganizationLocation = z.infer<typeof organizationLocationSchema>;

export const organizationSchema = z.object({
  code: z.string(),
  name: z.string(),
  locations: z.array(organizationLocationSchema),
});
export type Organization = z.infer<typeof organizationSchema>;

export const organizationsResponseSchema = z.object({
  organizations: z.array(organizationSchema),
});
export type OrganizationsResponse = z.infer<typeof organizationsResponseSchema>;
